// Services
import { AbstractDataClient } from '~/misc/services/data-client';

// Models
import { OpportunityModel } from '~/misc/opportunity/models';

export class OpportunityDataClient extends AbstractDataClient<OpportunityModel> {
  constructor() {
    super(new OpportunityModel());
  }
}
